import React from "react";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";

export const SendingEmailCompletedImage = () => {
  const isSpMode = useIsSpMode();
  return (
    <div css={container}>
      <div css={!isSpMode ? box : spModeBox}>
        <svg
          width="184"
          height="106"
          viewBox="0 0 184 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M63.5579 37.1488L154.96 3.14547C156.254 2.66405 157.694 3.32284 158.175 4.6169L181.044 66.0905C181.526 67.3845 180.867 68.8239 179.573 69.3053L88.1706 103.309C86.8765 103.79 85.4372 103.131 84.9558 101.837L62.0865 40.3636C61.6051 39.0696 62.2638 37.6302 63.5579 37.1488Z"
            stroke="black"
            strokeWidth="5"
          />
          <path
            d="M64.5 39.5591L123.894 54.6651L157 5.55908"
            stroke="black"
            strokeWidth="5"
          />
          <path d="M0 58.0591L52 58.0591" stroke="black" strokeWidth="3" />
          <path d="M8 74.0002L60 74.0002" stroke="black" strokeWidth="3" />
          <path
            d="M16.9995 89.0593L68.9995 89.0593"
            stroke="black"
            strokeWidth="3"
          />
        </svg>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  minHeight: "150px",
  padding: "18px 32px",
});

const spModeBox = css({
  minHeight: "150px",
  padding: "15px 17px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});
